import '@take-2/fd-modules/movie/layouts/desktop.app';
